module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "frontmatterpage01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _c('h2', {
    staticClass: "chapterTitle1"
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/005TOC#frontmatterpage_01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Author’s Note")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("I")])]), _vm._v(" would like to emphasize from the outset the focal point of this book is accusations over clinical procedures and decisions considered by most authorities and medical organizations to be both legal and ethical. The book is not about nurses and doctors such as Jack Kevorkian who espouse the practices of euthanasia (which is illegal throughout the United States) or even physician-assisted suicide (which is legal at this moment only in Oregon and Washington—and in Montana if a lower court decision is upheld). It is not about catastrophes such as occurred in New Orleans when Hurricane Katrina devastated Memorial Hospital and left medical staff isolated without basic resources to care for suffering and terminally ill patients. Neither is it about psychopathic medical professionals who are bona fide serial killers. Each of these separate issues is germane and will be touched upon, but they are not central.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("My primary concern is directed at the well-meaning clinicians who believe they offer reasonable end-of-life care and are then shocked to find themselves accused of murdering or euthanizing patients. I am writing about health care professionals who thoughtfully withdraw or withhold life support treatments and provide "), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("analgesic medications to alleviate pain and suffering. And I am equally curious about their accusers—mainly professional colleagues, but sometimes patients’ family members, who are chagrined by what they perceive to be modern medicine’s sprint to judge the quality of people’s lives, as well as an unseemly haste to relieve suffering at the cost of accelerating death.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  })]), _c('a', {
    attrs: {
      "id": "page12"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page12"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1334496","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006frontmatterpage.vue
// module id = 72
// module chunks = 0